import React from 'react'

const RequestContext = React.createContext();

export default RequestContext;
